import MyTable from "components/UIElements/MyTable";


export default function Alarms({ endPoint, exportFilename }) {


    const columns = [
        {
            title: 'PlateNo',
            key: 'plateNumber',
            dataIndex: 'plateNumber',
        },
        {
            title: 'PolicyNo',
            key: 'policyNumber',
            dataIndex: 'policyNumber',
        },
        {
            title: 'Channel',
            key: 'channel',
            dataIndex: 'channel'
        },
        {
            title: 'Alarm_Date',
            key: 'dateCreated',
            dataIndex: 'dateCreated',
        },
        {
            title: 'Alarm_Code',
            key: 'alarmType',
            dataIndex: 'alarmType',
        },
        {
            title: ' Alarm_Descr',
            key: 'alarmDescription',
            dataIndex: 'alarmDescription',
        },
        {
            title: 'DeviceType',
            key: 'deviceType',
            dataIndex: 'deviceType',
        },

    ]

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} />
}